import React from 'react';
import { StyledDivider } from './index.styles.js';
import {} from '@oneaudi/unified-web-common';
import { pickA11yProps } from '../../utils/pick-a11y-props.js';
import { pickDataProps } from '../../utils/pick-data-props.js';
export const Divider = ({ className, orientation, ariaHidden, margin, ...rest }) => {
    const a11yProps = pickA11yProps(rest);
    const dataProps = pickDataProps(rest);
    const roleProp = a11yProps['role'] ?? 'separator';
    return (React.createElement(StyledDivider, { ...a11yProps, ...dataProps, "$orientation": orientation, className: className, role: roleProp, "aria-orientation": orientation, "aria-hidden": ariaHidden, margin: margin }));
};
Divider.displayName = 'Divider';
//# sourceMappingURL=index.js.map